import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b5d4cf8&"
import script from "./composition.js?vue&type=script&lang=js&"
export * from "./composition.js?vue&type=script&lang=js&"
import style0 from "./styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports